import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, onChange, readOnly = false, size = 22 }) => {
  return (
    <div className="star-rating flex items-center">
      {[1, 2, 3, 4, 5].map((star) => (
        readOnly ? (
          <span key={star} className="p-0.5">
            <Star
              size={size}
              className={star <= rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}
            />
          </span>
        ) : (
          <button
            key={star}
            onClick={() => onChange?.(star)}
            data-testid={`star-${star}`}
            type="button"
            className="p-0.5 hover:scale-110 transition-transform"
          >
            <Star
              size={size}
              className={star <= rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300 hover:text-yellow-300'}
            />
          </button>
        )
      ))}
    </div>
  );
};

export default StarRating;